import(/* webpackMode: "eager" */ "/codebuild/output/src2655513001/src/apps/fanychance/src/app/error.tsx");
